// services/auth.js
import api from './api';

export const AuthAPI = {
  getMe: () => api.get('/me'),
  login: (credentials, system) => {
    if (!['eLearning', 'hmis', 'rafiki360', 'appeals'].includes(system)) {
      throw new Error(`Invalid system: ${system}`);
    }

    // Construct payload based on system
    let payload;
    if (system === 'eLearning') {
      payload = { auth: { email: credentials.email, password: credentials.password } };
    } else if (system === 'appeals') {
      payload = { email: credentials.email, password: credentials.password };
    } else {
      payload = { Username: credentials.email, password: credentials.password };
    }

    return api.post('/login', payload, { system }).then((response) => {
      // Normalize response to { token, user }
      if (system === 'eLearning') {
        const { token, data } = response.data;
        if (!token || !data) {
          throw new Error('Invalid E-Learning login response: Missing token or data');
        }
        return { token, user: data };
      } else if (system === 'appeals') {
        // Appeals returns { token, data } like eLearning
        const { token, data } = response.data;
        if (!token || !data) {
          throw new Error('Invalid Appeals login response: Missing token or data');
        }
        return { token, user: data };
      } else {
        const { data } = response.data;
        if (!data?.token || !data?.user) {
          throw new Error('Invalid login response: Missing token or user');
        }
        return { token: data.token, user: data.user };
      }
    });
  },
  googleSignup: (data) => api.post('/google_signup', data),
  signUp: (data) => api.post('/sign_up', data),
};